
import { Component, Prop } from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import '@/utils/transform.js';
import AlloyTouch from 'alloytouch';

import './style.less';

interface IMenu {
  visibility?: boolean,
  events?: object,
  data?: object
}

@Component
export default class Menu extends tsx.Component<IMenu>{
  
  @Prop() public visibility?: boolean;
  @Prop() public events?: object;
  @Prop() public data?: object;
  
  mounted () {
  
  }
  
  click (event: any){
    if (event.target.className === 'suspendedBall-container-menu') {
      this.$props.events.setMenuVisibility(false)
    }
  }
  
  render() {
    const {cloudplayHome,cloudplayMeun,cloudplayBackspace,cloudplayResolutionPhone, cloudplayExit} = this.$props.events;
    const {resolutionList = [], currentResolution = {}, pkgName} = this.$props.data;
    console.log(pkgName);
    return this.$props.visibility ? (
      <div onClick={this.click} class='suspendedBall-container-menu'>
        <div class='menu-container'>
          
          { pkgName === 'com.haima.cloudphone.phone' ?
            
            <div class='resolutionPhone-container'>
              <div class='resolutionPhone-title'>流畅度调节</div>
              <div class='resolutionPhone-button-container'>
                {resolutionList.map((item, index) => <div key={index} onClick={() => cloudplayResolutionPhone(item.id)} class={`resolutionPhone-button ${currentResolution.id === item.id && 'activate'}`}>{item.name}</div>)}
              </div>
            </div> : null
          }
          
          <div class='cloudplay-meun-container'>
            <div class='cloudplay-meun-title'>菜单按钮</div>
            <div class='cloudplay-meun-button-container-list'>
              <div onClick={cloudplayMeun} class='cloudplay-meun-button-container'>
                <img class='cloudplay-meun-button-img' src={require('@/assets/img/cloudplay-meun.png')} />
                <span class='cloudplay-meun-button-text'>切换</span>
              </div>
              <div onClick={cloudplayHome} class='cloudplay-meun-button-container'>
                <img class='cloudplay-meun-button-img' src={require('@/assets/img/cloudplay-home.png')} />
                <span class='cloudplay-meun-button-text'>首页</span>
              </div>
              <div onClick={cloudplayBackspace} class='cloudplay-meun-button-container'>
                <img class='cloudplay-meun-button-img' src={require('@/assets/img/cloudplay-backspace.png')} />
                <span class='cloudplay-meun-button-text'>返回</span>
              </div>
            </div>
          </div>
          
          <div onClick={() =>cloudplayExit(true)} class='menu-button'>退出云手机</div>
          
        </div>
      </div>
    ) : null
  }
  
}